export const token = localStorage.getItem("token");

export const setToken = token =>
  token ? localStorage.setItem("token", token) : localStorage.removeItem(token);
